class Footer extends DrupalBehavior {
  onReady(context) {
    const footer = document.querySelector('footer');
    if (!footer) {
      return;
    }
    this.footerMenuToggles = document.querySelectorAll('.footer--link-group--toggle');
    this.mql = window.matchMedia('(max-width: 767px)');
    this.bindEvents();
    this.mql.addListener(this.init);
    this.init(this.mql, context);
    this.socialIcons();
  }

  bindEvents() {
    this.init = this.init.bind(this);
  }

  socialIcons() {
    const links = document.querySelectorAll('.footer--social li');
    links.forEach((link) => {
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      const path = document.createElementNS("http://www.w3.org/2000/svg", 'path');

      svg.setAttribute('width', '39');
      svg.setAttribute('height', '39');
      svg.setAttribute('aria-hidden', 'true');

      path.setAttribute('d', 'M19.5 0a19.5 19.5 0 110 39 19.5 19.5 0 110-39');
      path.setAttribute('fill', 'none');
      path.setAttribute('stroke', '#FF5959');

      svg.appendChild(path);
      link.insertBefore(svg, link.childNodes[0]);
    })
  }

  preventMenuTitleDefault(e) {
    e.preventDefault();
  }

  toggleFooterMenu(e) {
    e.preventDefault();
    const toggle = e.target;
    const menuContent = toggle.parentNode.nextElementSibling;
    toggle.classList.toggle('open');
    if (toggle.classList.contains('open')) {
      toggle.setAttribute('aria-expanded', true);
      menuContent.classList.remove('hidden');
      gsap.to(menuContent, { duration: 0.4, ease: 'power4.out', height: 'auto' });
      menuContent.querySelector('a').focus();
    } else {
      toggle.setAttribute('aria-expanded', false);
      gsap.to(menuContent, { duration: 0.4, ease: 'power4.out', height: 0, onComplete: function() {
        menuContent.classList.add('hidden');
      } });
    }
  }

  init(media, context) {
    if (media.matches) {
      footerMenuToggles = once('footer-menu-mobile-behavior', '.footer--link-group--toggle', document);
      footerMenuToggles.forEach((toggle) => {
        toggle.classList.remove('open');
        toggle.setAttribute('aria-haspopup', true);
        toggle.setAttribute('aria-expanded', false);
        const menuContent = toggle.parentNode.nextElementSibling;
        menuContent.classList.add('hidden');
        menuContent.style.height = 0;

        toggle.addEventListener('click', this.toggleFooterMenu, true);
        toggle.removeEventListener('click', this.preventMenuTitleDefault, true);
      })
    } else {
      this.footerMenuToggles.forEach((toggle) => {
        toggle.removeAttribute('data-once');
        toggle.classList.add('open');
        toggle.setAttribute('aria-haspopup', false);
        toggle.setAttribute('aria-expanded', true);
        const menuContent = toggle.parentNode.nextElementSibling;
        menuContent.classList.remove('hidden');
        menuContent.style.height = 'auto';

        toggle.addEventListener('click', this.preventMenuTitleDefault, true);
        toggle.removeEventListener('click', this.toggleFooterMenu, true);
      })
    }
  }
}

DrupalBehavior.register('summit_theme', 'Footer', Footer);